import { BaseComponent } from 'components/BaseComponent';
import { times } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { Dropdown } from '../../../../components/Dropdown';
import { Times, CircleTimes } from '../../../../components/Icon';
import { Input } from '../../../../components/Input';
import { Loader } from '../../../../components/Loader';
import { selectMMT, selectNewVehicle, selectNewVehicleValue } from '../../selectors';
import cn from 'classnames';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './FieldModelName.module.css';
import { SearchSelect } from '../../../../components/SearchSelectComponent';

const Container = styled.div``;

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateFieldModelNameComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  onDropdownChange(evt) {
    const value = evt.value;
    if (value == 'manual') {
      this.props.onManual(true);
      this.props.onChange('');
    } else {
      this.props.onManual(false);
      this.props.onChange(evt.value);
    }
  }

  get value() {
    if (this.props.editInvoice) {
      return this.props.invoiceVehicleValue;
    }
    return this.props.value;
  }

  get brand() {
    if (this.props.editInvoice) {
      return this.props.invoiceVehicleBrand;
    }
    return this.props.values.brand_name;
  }

  render() {
    if (!this.props.mmt) return <Loader small />;
    let brand_id = this.props.mmt.brands.find(item => item.name == this.brand)?.id;

    let models = this.props.mmt.models.filter(m => m.brand_id == brand_id).map(m => m.name) || [];

    const options = models.map(name => ({ label: name, value: name })).concat([{ label: 'anders...', value: 'manual' }]);

    const selected = options.find(o => o.value == this.value);

    const manual = this.props.manual || this.props.values.brand_name_manual;

    if (this.value && !models.includes(this.value)) {
      this.props.onManual(true);
    }

    return (
      <Container>
        {!manual && !this.props.value ? (
          <div>
            <SearchSelect
              options={options}
              value={selected}
              onChange={this.onDropdownChange.bind(this)}
              disabled={this.props.manual}
            />
          </div>
        ) : (
          <div className={styles.buttonLabel}>
            <div className={styles.labelCompany}>
              <input
                className="form-control"
                value={this.props.value}
                onChange={evt => this.props.onChange(evt.target.value)}
                name="value"
              />
            </div>

            <ButtonComponent
              style={'ButtonSoftDelete'}
              onClick={() => {
                this.props.deletable && this.props.onDeleteValue(this.props.value);
                this.props.onManual(false);
                this.props.onReset && this.props.onReset();
              }}
            >
              <CircleTimes />
            </ButtonComponent>
          </div>
        )}
      </Container>
    );
  }
}

VehicleCreateFieldModelNameComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    value: selectNewVehicleValue(ownProps.type),
    values: selectNewVehicle(),
    manual: selectNewVehicleValue(`${ownProps.type}_manual`),
    mmt: selectMMT(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateFieldModelName = compose(withConnect, withRouter)(VehicleCreateFieldModelNameComp);
